<template>

  <div class="service_form_details">
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="5"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              Receipt Details - {{ receiptDetail.trxNo }}
            </h1>
            <p class="log_info">
              Receipt created by {{ getCreatedBy() }} on {{ getCreatedAt() }}<br>Last updated on {{ getUpdatedAt() }}
            </p>
          </b-col>
        </b-row>
      </b-col>

      <!-- Content Right -->
      <b-col
        class="content-header-right text-md-right mb-1"
        md="7"
        lg="7"
        cols="12"
      >
        <div class="user_block no-min-width file_payment_type user__block-margin-adjust">
          <div class="text-right ml-auto vendor-detail-more-icon file_detail_tab_end">
            <b-dropdown
              variant="flat-primary"
              no-caret
              class=""
              :right="$store.state.appConfig.isRTL"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreHorizontalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="canViewThisAction('download', 'Receipt')"
                @click="downloadReceipt()"
              >
                <feather-icon icon="DownloadIcon" />
                <span class="align-middle ml-50">Download Receipt</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="canViewThisAction('send-email', 'Receipt')"
                @click="openEmailStatementModal()"
              >
                <feather-icon icon="MailIcon" />
                <span class="align-middle ml-50">Email Receipt to Customer</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="user_block pr_stage_type user__block-margin-adjust">
          <div class="user_avatar" />
          <div class="user_info">
            <h6>Receipt Status</h6>
            <h5
              class="text-capitalize"
              :class="`text-${resolveReceiptStatusVariant(receiptDetail.status)}`"
            >
              {{ receiptDetail.status }}
            </h5>
          </div>
        </div>
        <div class="user_block user__block-margin-adjust">
          <div class="user_avatar">
            <img :src="agent.image ? agent.image : defaultImage">
          </div>
          <div class="user_info">
            <h6>Service Agent</h6>
            <h5>{{ agent.name ? agent.name : '' }}</h5>
          </div>
          <!-- <div class="action_button">
                  <b-button
                    v-if="canViewThisAction('update', 'Receipt') || canViewThisAction('update-assignee', 'Receipt')"
                    variant="flat-primary"
                    @click="setDutyOfficerModal()"
                  >
                    <feather-icon
                      icon="EditIcon"
                      class="mr-50"
                      size="16"
                    />
                  </b-button>
                  <b-button
                    v-else
                    v-b-tooltip.hover.bottom="'You don’t have permission to edit this information.'"
                    variant="flat-primary"
                    style="opacity: 0.65;"
                    aria-readonly=""
                  >
                    <feather-icon
                      icon="EditIcon"
                      class="mr-50"
                      size="16"
                    />
                  </b-button>
                </div> -->
        </div>
      </b-col>
    </b-row>
    <!-- Table Container Card -->

    <b-row class="match-height">
      <b-col md="6">
        <b-card
          title="Receipt Information"
          class="no-padding-td receipt_info"
        >
          <b-table-simple
            borderless
            responsive
            class="particulars_of_deceased d-none d-md-block"
          >
            <b-tbody>
              <b-tr>
                <b-th width="230px">
                  Paid Amount
                </b-th>
                <b-td>{{ receiptDetail.amount ? `$${numberFormat(receiptDetail.amount)}` : '-' }}</b-td>
              </b-tr>
              <b-tr>
                <b-th width="230px">
                  Bank In Description
                </b-th>
                <b-td>{{ receiptDetail.bank ? receiptDetail.bank : '-' }}</b-td>
              </b-tr>
              <b-tr>
                <b-th width="230px">
                  Transaction Date
                </b-th>
                <b-td>{{ receiptDetail.trxDate ? dateFormat(receiptDetail.trxDate) : '-' }}</b-td>
              </b-tr>
              <b-tr>
                <b-th width="230px">
                  Remarks
                </b-th>
                <b-td>
                  <div class="d-flex remark_info_item">
                    {{ receiptDetail.remarks ? receiptDetail.remarks : '-' }}
                    <b-button
                      v-if="canViewThisAction('update', 'Receipt')"
                      v-b-tooltip.hover.top="'Edit Remarks'"
                      variant="flat-primary"
                      class="ml-auto p-0"
                      @click="receiptRemarksEdit"
                    >
                      <feather-icon
                        class="cursor-pointer"
                        icon="EditIcon"
                        size="16"
                      />
                    </b-button>
                  </div>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card
          v-if="receiptDetail.nvsFileID"
          title="Product and Customer Details"
          class="no-padding-td"
        >
          <b-table-simple
            borderless
            responsive
            class="particulars_of_deceased d-none d-md-block"
          >
            <b-tbody>
              <b-tr>
                <b-th width="230px">
                  File No.
                </b-th>
                <b-td>
                  <b-button
                    v-if="canViewThisAction('show', 'File')"
                    variant="link"
                    class="weight-600 align-middle detail-view-id text-uppercase"
                    :to="{ name: 'customers-files-show', params: { id: receiptDetail.fileID || 0 } }"
                  >
                    {{ receiptDetail.fileNo }}
                  </b-button>
                  <span v-else>{{ receiptDetail.fileNo }}</span>
                  (Status: <span :class="`text-${resolveFileStatusVariant(receiptDetail.nvsFileID.nvsFileStatus)} weight-600`">{{ receiptDetail.nvsFileID.nvsFileStatus ? receiptDetail.nvsFileID.nvsFileStatus : '-' }}</span>)
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230px">
                  Product Description
                </b-th>
                <b-td>{{ receiptDetail.nvsFileType ? receiptDetail.nvsFileType : '-' }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <hr>
          <b-table-simple
            borderless
            responsive
            class="particulars_of_deceased d-none d-md-block"
          >
            <b-tbody>
              <b-tr>
                <b-th width="230px">
                  Customer Name
                </b-th>
                <b-td class="text-uppercase">
                  <!-- {{ customer.name ? customer.name : '-' }} -->
                  <b-button
                    v-if="canViewThisAction('show', 'Customer') && customer.customer"
                    v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                    variant="link"
                    class="weight-600 align-middle detail-view-id text-uppercase"
                    :to="{ name: 'customers-customers-show', params: { id: customer.customer || 0 } }"
                  >
                    {{ customer.name ? customer.name : '-' }}
                  </b-button>
                  <b-button
                    v-else
                    v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                    variant="none"
                    class="text-bold-black align-middle not-button text-uppercase"
                  >
                    {{ customer.name ? customer.name : '-' }}
                  </b-button>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230px">
                  NRIC No.
                </b-th>
                <b-td>{{ customer.encryptedNric ? customer.encryptedNric : '-' }}</b-td>
              </b-tr>
              <b-tr>
                <b-th width="230px">
                  Mobile No.
                </b-th>
                <b-td>{{ customer.contact ? customer.contact : '-' }}</b-td>
              </b-tr>
              <b-tr>
                <b-th width="230px">
                  Email address
                </b-th>
                <b-td>{{ customer.email ? customer.email : '-' }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
    </b-row>

    <b-card
      title="Payment Information"
      class="mb-3 mt-1 p-2"
    >
      <b-card-text>
        <Payment :transactions="receiptDetail.transactions" />
      </b-card-text>
    </b-card>

    <b-card
      title="Receipt/ Credit Note Allocation"
      class="mb-3 mt-3 p-2"
    >
      <b-card-text>
        <Allocation :allocations="receiptDetail.allocations" />
      </b-card-text>
    </b-card>

    <b-card
      title="Attachments"
      class="mb-3 mt-3 p-2"
    >
      <input
        ref="hiddenAllocationFileInput"
        type="file"
        multiple
        capture
        accept="image/jpeg, image/png, application/pdf"
        class="d-none"
        @change="setAttachment"
      >
      <b-row v-if="receiptAttachments.length">
        <!-- Content Left -->
        <b-col
          v-for="(file, key) in receiptAttachments"
          :key="key"
          class="content-header-left mb-2"
          cols="12"
          md="4"
        >
          <div
            class="attachment-item"
          >
            <b-img
              v-if="file.type.includes('image')"
              left
              height="40"
              :src="require('@/assets/images/admin/doc_jpg.png')"
              alt="Left image"
            />
            <b-img
              v-if="file.type.includes('application')"
              left
              height="40"
              :src="require('@/assets/images/admin/doc_file.png')"
              alt="Left image"
            />
            <strong>
              <b-link
                v-if="file.fileStorage"
                :to="{ name: 'file-view', params: { id: file.fileStorage } }"
                target="_blank"
              >
                {{ file ? file.name : '' }}
              </b-link>
              <b-link
                v-else-if="file.data"
                :href="file ? file.data : ''"
                target="_blank"
              >
                {{ file ? file.name : '' }}
              </b-link>
            </strong>
            <span>{{ file ? `${file.size}mb` : '' }}</span>
            <span class="remove__doc">
              <b-button
                v-if="canViewThisAction('update', 'Receipt')"
                variant="flat-primary"
                @click="removeAttachment(file.name, file._id)"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-50"
                  size="18"
                />
              </b-button>
            </span>
          </div>
          <div class="doc__desc new_design">
            <span v-if="file.description">
              {{ file.description }}
            </span>
            <span v-else>
              <button
                v-if="canViewThisAction('update', 'Receipt')"
                @click="updateDescription(key)"
              >
                Add a description
              </button>
            </span>
            <span
              v-if="file.description"
              class="edit__desc"
            >
              <b-button
                v-if="canViewThisAction('update', 'Receipt')"
                variant="flat-primary"
                @click="updateDescription(key)"
              >
                <feather-icon
                  icon="EditIcon"
                  class="mr-50"
                  size="18"
                />
              </b-button>
            </span>
          </div>
        </b-col>
        <b-col
          class="content-header-left mb-2"
          cols="12"
          md="4"
        >
          <b-button
            v-if="canViewThisAction('update', 'Receipt')"
            variant="link"
            class="mr-1 md-mb-1"
            @click="$refs.hiddenAllocationFileInput.click()"
          >
            <feather-icon
              icon="UploadIcon"
              size="20"
              class="mr-50"
            />
            <span
              class="align-middle"
              style="font-weight: 500; font-size: 14px;"
            >
              Upload
            </span>
          </b-button>
          <b-button
            v-if="attachments.length"
            variant="success"
            class="mr-1 md-mb-1"
            @click="uploadFile"
          >
            Save File
          </b-button>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <div class="empty_block">
            <h4>Nothing in here yet</h4>
            <b-button
              v-if="canViewThisAction('update', 'Receipt')"
              variant="link"
              class=""
              @click="$refs.hiddenAllocationFileInput.click()"
            >
              <feather-icon
                icon="UploadIcon"
                size="20"
                class="mr-50"
              />
              <span
                class="align-middle"
                style="font-weight: 500; font-size: 14px;"
              >
                Upload
              </span>
            </b-button>
            <b-button
              v-if="attachments.length"
              variant="success"
              class="mr-1 md-mb-1"
              @click="uploadFile"
            >
              Save File
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-card
      class="mb-3 mt-3 p-2"
    >
      <b-row
        class="content-header"
      >
        <!-- Content Left -->
        <b-col
          class="content-header-left pb-2"
          cols="12"
          md="12"
        >
          <h4>
            <feather-icon
              icon="ListIcon"
              class="mr-50"
              size="16"
            />
            <span class="align-middle">Activity Logs</span>
          </h4>
        </b-col>
      </b-row>
      <app-timeline>
        <!-- FINANCIAL REPORT -->
        <app-timeline-item
          v-for="(opt, key) in receiptDetailActivityLogs"
          :key="key"
          :variant="getVariant(key)"
        >

          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
            <h6>{{ opt.title }}</h6>
            <small class="text-muted">{{ dateFormatWithTime(opt.time) }}</small>
          </div>
          <b-button
            v-if="opt.activityDetails && opt.activityDetails.length"
            v-b-toggle="'report-list-with-icon-' + key"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            size="sm"
            variant="outline-primary"
          >
            Details
            <feather-icon
              icon="ChevronUpIcon"
              class="ml-50 when-open"
              size="16"
            />
            <feather-icon
              icon="ChevronDownIcon"
              class="ml-50 when-closed"
              size="16"
            />
          </b-button>
          <b-collapse
            v-if="opt.activityDetails && opt.activityDetails.length"
            :id="'report-list-with-icon-' + key"
          >
            <b-table-simple
              borderless
              responsive
            >
              <b-tbody>
                <b-tr
                  v-for="(activityDetail, activitykey) in opt.activityDetails"
                  :key="activitykey"
                >
                  <b-th style="width: 300px; max-width: 300px;">
                    {{ activityDetail.title }}
                  </b-th>
                  <b-td>{{ activityDetail.oldValue }}</b-td>
                  <b-td>{{ activityDetail.newValue }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-collapse>
        </app-timeline-item>
      </app-timeline>
    </b-card>

    <b-modal
      id="modal-attachment-description"
      size="lg"
      title="Attachment Description"
      modal-class="status-update-modal"
      centered
      no-stacking
      header-class="front-modal"
      @ok="saveDescription"
      @cancel="closeDescriptionModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-textarea
            id="h-customer-phone-number"
            v-model="description"
            placeholder="E.g. Payment Schedule"
          />
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="!description || attachmentKey === ''"
          @click="ok()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-receipts-remarks"
      size="sm"
      title="Edit Remarks"
      modal-class="status-update-modal"
      centered
      no-stacking
      header-class="front-modal"
      footer-class="iu-edit-modal-footer"
      @ok="saveReceiptRemarks"
      @cancel="closeReceiptRemarksModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-textarea
            id="h-customer-phone-number"
            v-model="receiptRemarks"
            rows="6"
            placeholder="E.g. Payment Schedule"
          />
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="!receiptRemarks"
          @click="ok()"
        >
          <span class="align-middle">Save Changes</span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="email-statement-modal"
      ref="email-statement-modal"
      modal-class="status-update-modal sign-modal-adjust sign-form_modal-adjust"
      centered
      no-stacking
      no-close-on-backdrop
      header-class="front-modal"
      title="Email Receipt to Customer"
      @ok="sendEmailStatement"
      @cancel="closeStatementModal"
    >
      <div class="">
        <b-form-group
          label="Customer Name"
          label-for="customer-name"
          class="mb-20"
        >
          <validation-provider
            #default="{ errors }"
            name="Customer Name"
            vid="customer-name"
            rules=""
          >
            <b-form-input
              id="customer-name"
              v-model="customerNameVal"
              placeholder="Lin Chai"
              class="mb-0 text-uppercase"
              readonly
              :state="(errors.length > 0) ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Email Address"
          label-for="customer-email"
          class="mb-20"
        >
          <validation-provider
            #default="{ errors }"
            name="Email Address"
            vid="customer-email"
            rules="required"
          >
            <b-form-input
              id="customer-email"
              v-model="customerEmailVal"
              placeholder="email@domain.com"
              class="mb-0"
              :readonly="hasEmailAddress ? true : false"
              :state="(errors.length > 0) ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Message"
          label-for="statement-message"
          class="mb-20"
        >
          <validation-provider
            #default="{ errors }"
            name="Message"
            vid="statement-message"
            rules="required"
          >
            <b-form-textarea
              id="statement-message"
              v-model="statementMessage"
              placeholder="Statement of Account"
              class="mb-0"
              rows="5"
              :state="(errors.length > 0) ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="success"
          class="custom-icon"
          :disabled="!customerEmailVal"
          @click="ok()"
        >
          <feather-icon
            icon="SendIcon"
            size="16"
            class="mr-50"
          />
          <span class="align-middle">Send</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BCard, BCardText, BRow, BButton, BCol, BTableSimple, BTbody, BTr, BTh, BTd, VBToggle, VBTooltip, BCollapse,
  BDropdown, BDropdownItem, BImg, BFormTextarea, BLink, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import store from '@/store/index'
import moment from 'moment'
import { required } from '@validations'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import Ripple from 'vue-ripple-directive'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Payment from './Payment.vue'
import Allocation from './Allocation.vue'

import ToastificationContentCustom from '../../operation/ToastificationContentCustom.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BButton,
    BCol,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BCollapse,
    BDropdown,
    BDropdownItem,
    BImg,
    BFormTextarea,
    BLink,
    BFormGroup,
    BFormInput,

    ValidationProvider,

    Payment,
    Allocation,
    AppTimeline,
    AppTimelineItem,
  },
  directives: { 'b-toggle': VBToggle, 'b-tooltip': VBTooltip, Ripple },
  data() {
    return {
      canViewThisAction,
      user: store.state.auth.userData,
      receiptDetail: {},
      // receiptDetail: JSON.parse(localStorage.getItem('customerReceiptDetail')),
      receiptDetailID: '',
      receiptDetailActivityLogs: [],
      receiptAttachments: [],
      required,
      // eslint-disable-next-line global-require
      defaultImage: require('@/assets/images/frontend/logo-nirvana-memorial-garden.86fe2ff5.svg'),
      currentTabTitle: 'File Details',
      activeTab: 0,
      attachments: [],
      description: '',
      attachmentKey: '',
      receiptRemarks: '',
      nvsReceiptID: '',
      oldRemarks: '',
      receiptID: '',
      fileID: '',
      fileNo: '',
      fileType: '',
      nvsFileType: '',
      customerNameVal: '',
      customerEmailVal: '',
      hasEmailAddress: '',
      customerContactVal: '',
      statementMessage: '',
      agent: {},
      customer: {},
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.fetchReceiptDetail()
    // document.title = `${this.receiptDetail.fileNo} - ${this.receiptDetail.fileType} | ${process.env.VUE_APP_APP_NAME || 'Nirvana Memorial Garden'}`
    // store.commit('breadcrumb/REMOVE_BREADCRUMB')
    // const newMeta = {
    //   active: true,
    //   text: `${this.receiptDetail.fileNo} - ${this.receiptDetail.fileType}`,
    // }
    // store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
    // this.receiptDetailActivityLogs = this.receiptDetail.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
  },
  methods: {
    getCreatedBy() {
      if (this.receiptDetail.createdByCustomer) {
        return this.receiptDetail.createdByCustomer.name
      }
      if (this.receiptDetail.createdByNvs) {
        return this.receiptDetail.createdByNvs.name
      }
      if (this.receiptDetail.createdBy) {
        return this.receiptDetail.createdBy
      }

      return ''
    },
    getCreatedAt() {
      if (this.receiptDetail.createdAtNvs) {
        return this.dateFormatWithTime(this.receiptDetail.createdAtNvs)
      }
      if (this.receiptDetail.createdAt) {
        return this.dateFormatWithFormatNTZ(this.receiptDetail.createdAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    getUpdatedAt() {
      if (this.receiptDetail.updatedAtNvs) {
        return this.dateFormatWithTime(this.receiptDetail.updatedAtNvs)
      }
      if (this.receiptDetail.updatedAt) {
        return this.dateFormatWithFormatNTZ(this.receiptDetail.updatedAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    fetchReceiptDetail() {
      this.$http.get(`customer/receipts/${this.$route.params.id}/show`)
        .then(response => {
          if (response.data.receipt.trxID) {
            this.receiptDetail = response.data.receipt || {}
            if (this.receiptDetail.nvsFileID) {
              if (this.receiptDetail.nvsFileID.agents && this.receiptDetail.nvsFileID.agents.length) {
                // eslint-disable-next-line prefer-destructuring
                this.agent = this.receiptDetail.nvsFileID.agents[0]
              }
              if (this.receiptDetail.nvsFileID.purchasers && this.receiptDetail.nvsFileID.purchasers.length) {
                // eslint-disable-next-line prefer-destructuring
                this.customer = this.receiptDetail.nvsFileID.purchasers[0]
              }
            }
            document.title = `Receipt - ${this.receiptDetail.trxNo} | ${process.env.VUE_APP_APP_NAME || 'Nirvana Memorial Garden'}`
            // localStorage.setItem('customerReceiptDetail', JSON.stringify(this.receiptDetail))
            store.commit('breadcrumb/REMOVE_BREADCRUMB')
            const newMeta = {
              active: true,
              text: `Receipt Details - ${this.receiptDetail.trxNo}`,
            }
            store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
            this.receiptDetailActivityLogs = this.receiptDetail.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.receiptAttachments = this.receiptDetail.attachments.filter(file => file.fileStorage)
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    changeTab(index, tabName) {
      this.activeTab = index
      this.currentTabTitle = tabName
    },
    resolveReceiptStatusVariant(status) {
      if (status === 'Paid') return 'success'
      if (status === 'Void') return 'danger'
      return 'primary'
    },
    resolveFileStatusVariant(status) {
      if (status === 'OPEN') return 'warning'
      if (status === 'BOOK') return 'info'
      return 'success'
    },
    resolvePaymentStatusVariant(status) {
      if (status === 'Fully Paid') return 'success'
      if (status === 'Ongoing Installment') return 'info'
      if (status === 'Pending Payment') return 'warning'
      if (status === 'Reactivation Fee') return 'danger'
      return 'secondary'
    },
    getVariant(key) {
      if (key % 4 === 0) return 'info'
      if (key % 4 === 1) return 'warning'
      if (key % 4 === 2) return 'danger'
      if (key % 4 === 3) return 'purple'
      return 'primary'
    },
    removeAttachment(name, id) {
      this.$http
        .post('customer/receipts/attachment/remove', { id, name, receiptID: this.receiptDetail._id })
        .then(response => {
          this.receiptAttachments = response.data.data.attachments.filter(file => file.fileStorage)
          this.receiptDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    setAttachment(e) {
      if (e.target.files.length) {
        // const reader = new FileReader()
        // reader.readAsDataURL(this.file)
        // reader.onload = () => {
        //   e.target.filesrc = reader.result
        // }
        const acceptedTypes = ['image/jpeg', 'image/png', 'application/pdf']
        e.target.files.forEach(element => {
          if (acceptedTypes.includes(element.type)) {
            if (element.size > 20 * 1024 * 1024) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Can't add files more than 20mb",
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            } else {
              // const reader = new FileReader()
              // reader.readAsDataURL(element)

              // reader.onload = event => {
              //   const fileObj = {}
              //   fileObj.name = element.name
              //   fileObj.data = event.target.result
              //   fileObj.size = (element.size / (1024 * 1024)).toFixed(2)
              //   fileObj.type = element.type
              //   this.attachments.push(fileObj)
              // }
              const fileObj = {}
              fileObj.name = element.name
              fileObj.data = element
              fileObj.size = (element.size / (1024 * 1024)).toFixed(2)
              fileObj.type = element.type
              fileObj.description = ''
              fileObj.storage = 'local'
              this.attachments.push(fileObj)
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Unsupported file type',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
      }
    },
    async uploadFile() {
      store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', true)
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.attachments.length; i++) {
        // eslint-disable-next-line no-await-in-loop
        const res = await this.uploadFileToAws(this.attachments[i].data)
        const { fileUrl, fileName, upload } = res
        const formData = new FormData()
        if (upload && fileUrl) {
          this.attachments[i].data = fileName
          this.attachments[i].storage = 'aws'
          formData.append('sAttachments', JSON.stringify([this.attachments[i]]))
        } else {
          formData.append('attachments', this.attachments[i].data)
        }

        formData.append('shouldUpload', (upload && fileUrl))
        formData.append('receiptID', this.$route.params.id)
        formData.append('id', this.receiptDetail._id)

        if (i === this.attachments.length - 1) {
          store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', false)
        }

        this.$http.post('customer/receipts/attachment/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(response => {
            this.receiptAttachments = response.data.data.attachments.filter(file => file.fileStorage)
            this.receiptDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'success',
              },
            })
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      }

      this.attachments = []
    },
    closeDescriptionModal() {
      this.$root.$emit('bv::hide::modal', 'modal-attachment-description', '')
    },
    updateDescription(key) {
      this.attachmentKey = key
      this.description = this.receiptAttachments[key].description
      this.$root.$emit('bv::show::modal', 'modal-attachment-description', '')
    },
    downloadReceipt() {
      const formData = new FormData()
      formData.append('url', window.location.origin)
      formData.append('receiptID', this.$route.params.id)
      formData.append('id', this.receiptDetail._id)
      this.$http.post('customer/receipts/pdf/download', formData, {
        headers: { Accept: 'application/pdf' },
        responseType: 'arraybuffer',
      })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `Receipt-${this.receiptDetail.trxNo}.pdf`
          link.click()

          link.remove()
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    openEmailStatementModal() {
      this.receiptID = this.receiptDetail.trxID
      if (this.receiptDetail.purchasers && this.receiptDetail.purchasers.length) {
        const firstPurchaser = this.receiptDetail.purchasers[0]
        this.hasEmailAddress = this.customer.email ? this.customer.email : ''
        this.customerNameVal = firstPurchaser.name ? firstPurchaser.name : ''
        this.customerEmailVal = this.customer.email ? this.customer.email : ''
        this.customerContactVal = firstPurchaser.contact ? firstPurchaser.contact : ''
        this.fileType = this.receiptDetail.nvsFileType ? this.receiptDetail.nvsFileType : ''
        this.fileNo = this.receiptDetail.fileNo ? this.receiptDetail.fileNo : ''
        this.fileID = this.receiptDetail.fileID ? this.receiptDetail.fileID : ''
        this.statementMessage = `Here is the Receipt for your purchase with us for ${this.receiptDetail.nvsFileType} (file no.: ${this.receiptDetail.fileNo}), as at ${moment().format('DD MMM YYYY')}. We appreciate your business and look forward to serving you again.`
        this.$root.$emit('bv::show::modal', 'email-statement-modal', '')
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Purchaser Data is missing',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    closeStatementModal() {
      this.$root.$emit('bv::hide::modal', 'email-statement-modal', '')
    },
    sendEmailStatement() {
      let contact = this.customerEmailVal
      if (this.customerContactVal) {
        contact = this.customerContactVal.slice(-8)
      }
      const formData = new FormData()
      formData.append('customerName', this.customerNameVal)
      formData.append('customerEmail', this.customerEmailVal)
      formData.append('message', this.statementMessage)
      formData.append('fileType', this.fileType)
      formData.append('fileNo', this.fileNo)
      formData.append('contact', contact)
      formData.append('fileID', this.fileID)
      formData.append('receiptID', this.receiptID)
      formData.append('url', `${window.location.origin}`)

      this.$http.post('customer/receipts/email/pdf', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          this.receiptDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
          this.$toast({
            component: ToastificationContentCustom,
            props: {
              title: 'Receipt Sent',
              text: response.data.message,
              icon: 'CheckCircleIcon',
              variant: 'success',
              hideClose: true,
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    receiptRemarksEdit() {
      this.receiptRemarks = this.receiptDetail.remarks
      this.$root.$emit('bv::show::modal', 'modal-receipts-remarks', '')
    },
    saveReceiptRemarks() {
      this.$http
        .post('customer/receipts/save/remarks', {
          remarks: this.receiptRemarks,
          oldRemarks: this.receiptDetail.remarks,
          receiptID: this.$route.params.id,
          nvsReceiptID: this.receiptDetail._id,
          updatedAt: this.receiptDetail.updatedAt ? moment(this.receiptDetail.updatedAt).utc().format('YYYY-MM-DDTHH:mm:ss') : null,
        })
        .then(response => {
          if (response.data.success) {
            this.receiptDetail.remarks = this.receiptRemarks
            this.receiptDetail.updatedAt = response.data.receipt.updatedAt
            this.receiptDetailActivityLogs = response.data.receipt.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.closeReceiptRemarksModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'success',
              },
            })
          } else {
            this.closeReceiptRemarksModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    closeReceiptRemarksModal() {
      this.$root.$emit('bv::hide::modal', 'modal-receipts-remarks', '')
    },
    saveDescription() {
      const id = this.receiptAttachments[this.attachmentKey]._id
      this.$http
        .post('customer/receipts/attachment/save-description', { id, description: this.description, receiptID: this.receiptDetail._id })
        .then(response => {
          this.receiptAttachments = response.data.data.attachments.filter(file => file.fileStorage)
          this.closeDescriptionModal()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style>
.timeline-variant-info .timeline-item-point {
    background-color: #00cfe8 !important;
}
.timeline-variant-purple .timeline-item-point {
    background-color: #7367F0 !important;
}
.tab-parent .nav-item {
    margin-bottom: 0.75rem !important;
}
</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-email.scss";
</style>
